module.exports = __webpack_public_path__ + "img/empty.23d7345d.svg";